
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import ConsumptionModal from '@/views/workbenches/subassembly/ConsumptionModal.vue';
import { getCurrentMonth } from '@/common/utils';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';
import moment from 'moment';
import ShopService from '@/services/shop.service';
import {
  City,
} from '@/common/interface/shop';

@Component({
  components: {
    ConsumptionModal,
  },
})
export default class ConsumptionDetails extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;
  @lazyInject(ShopService)
  shopService!: ShopService;
  @Ref()
  consumptionModal!: ConsumptionModal;
  form: any = {
    month: '',
    dept_id: undefined,
    group_id: undefined,
    poi: '',
    shopName: '',
    city: '',
    agentName: '',
  };
  pagination = {
    current: 1,
    pageSize: 10,
    total: 0,
    onChange: this.handleChangePage,
  };
  dept_list: any = [];
  group_list: any = [];
  columns = [
    {
      title: '部',
      dataIndex: 'dept_name',
      key: 'dept_name',
      align: 'center',
    },
    {
      title: '组',
      dataIndex: 'group_name',
      key: 'group_name',
      align: 'center',
    },
    {
      title: '广告代运营',
      dataIndex: 'agent_name',
      key: 'agent_name',
      align: 'center',
    },
    {
      title: '城市',
      dataIndex: 'city_name',
      key: 'city_name',
      align: 'center',
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
    },
    {
      title: '门店名称',
      dataIndex: 'name',
      key: 'storeName',
      align: 'center',
    },
    {
      title: '广告主',
      dataIndex: 'advertiser_id',
      key: 'advertiser_id',
      align: 'center',
    },
    {
      title: '月累计消耗',
      dataIndex: 'month_accumulat_campaign',
      key: 'month_accumulat_campaign',
      align: 'center',
    },
    {
      dataIndex: 'day_avg_campaign',
      key: 'day_avg_campaign',
      align: 'center',
      slots: { title: 'day_avg_campaign' },
    },
    {
      title: '操作',
      key: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
    },
  ];
  dataList = [];
  citys: City[] = [];
  @Watch('$route.query')
  handleQuery() {
    const { dept_id, group_id, agentName, month, poi, shopName, city, page, pageSize, old_query } = this.$route.query;
    const query: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (dept_id) {
      query.deptId = dept_id;
      this.form.dept_id = +dept_id;
    }
    if (group_id) {
      query.groupId = group_id;
      this.form.group_id = +group_id;
    }
    if (month) {
      query.month = month;
      this.form.month = month;
    }
    if (poi) {
      query.poiId = poi;
      this.form.poi = poi;
    }
    if (shopName) {
      query.shopName = shopName;
      this.form.shopName = shopName;
    }
    if (city) {
      query.city = city;
      this.form.city = +city;
    }
    if (agentName) {
      query.agentName = agentName;
      this.form.agentName = agentName;
    }
    if (old_query) {
      this.old_query = JSON.parse(old_query as string);
    }
    this.getConsumptionDetails(query);
  }

  old_query: any = {
    dept_id: undefined,
    group_id: undefined,
    month: '',
    type: '',
    module: 'ad_campaign_cost',
  };
  /** 省市过滤 */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  regionFilterOption(input: string, option: any) {
    return (
      option.componentOptions.children[0].text
        .toLowerCase()
        .indexOf(input.toLowerCase()) >= 0
    );
  }
  /** 获取城市里列表 */
  async getCityList() {
    const response = (await this.shopService.getCityList()) as unknown as {
      [key: string]: {
        province: City;
        city: City[];
      };
    };
    if (response) {
      const citys = Object.values(response)
        .map((item) => item.city)
        .reduce((prev, cur) => prev.concat(cur), []);
      this.citys = citys;
    } else {
      this.citys = [];
    }
  }
  mounted() {
    this.getDeptInfo();
    this.getCityList();
    this.handleQuery();
  }
  handleChangeMonth(date: any) {
    this.form.month = moment(date).format('YYYY-MM');
  }
  async getDeptInfo() {
    const res = await this.workbenchesService.getDeptInfo();
    this.dept_list = res;
    const { dept_id } = this.$route.query;
    if (!dept_id) return;
    const deptId = Number(dept_id);
    this.group_list = this.dept_list.find((item: any) => item.dept.id === deptId).group;
  }
  selectOption(val: any) {
    this.group_list = this.dept_list.find((res: any) => res.dept.id === val).group;
    this.form.group_id = undefined;
  }
  refresh() {
  }
  search() {
    this.pagination.current = 1;
    this.getQuery();
  }
  handleChangePage(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQuery();
  }
  getQuery() {
    const { month, dept_id, group_id, poi, shopName, city, agentName } = this.form;
    const { current, pageSize } = this.pagination;
    const query: any = {
      page: current,
      pageSize,
      old_query: JSON.stringify(this.old_query),
    };
    if (month) {
      query.month = month;
    }
    if (dept_id) {
      query.dept_id = dept_id;
    }
    if (group_id) {
      query.group_id = group_id;
    }
    if (poi) {
      query.poi = poi;
    }
    if (shopName) {
      query.shopName = shopName;
    }
    if (city) {
      query.city = +city;
    }
    if (agentName) {
      query.agentName = agentName;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }
  reset() {
    this.pagination.current = 1;
    this.form = {
      month: '',
      dept_id: undefined,
      group_id: undefined,
      poi: '',
      shopName: '',
      city: '',
      agentName: '',
    };
    const query: any = {
      page: 1,
      pageSize: 10,
      old_query: JSON.stringify(this.old_query),
    };
    query.month = getCurrentMonth();
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }
  handleClick(value: any) {
    const _data = {
      agentId: value.agent_id,
      shopId: value.shopId,
      month: this.form.month,
    };
    this.consumptionModal.init(_data);
  }
  back() {
    this.$router.push({
      name: 'workbenches.PromotionCompletionRate',
      query: {
        ...this.old_query,
      },
    });
  }


  async getConsumptionDetails(query: any) {
    const res = await this.workbenchesService.getAdConsumeList(query);
    this.dataList = res.list;
    this.pagination.current = res.page;
    this.pagination.total = res.total;
  }
}
